
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { AreaChart, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Area } from "recharts";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { dadosDespesas } from "./DadosRelatorios";

const DespesasChart = () => {
  return (
    <Card className="border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-semibold text-gray-800">Despesas por Mês</CardTitle>
        <CardDescription>Evolução das despesas nos últimos meses</CardDescription>
      </CardHeader>
      <CardContent className="h-[300px]">
        <ChartContainer
          config={{
            valor: { label: "Valor", color: "rgba(239, 68, 68, 0.8)" },
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={dadosDespesas}
              margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
            >
              <defs>
                <linearGradient id="colorDespesas" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="rgba(239, 68, 68, 0.8)" stopOpacity={0.8}/>
                  <stop offset="95%" stopColor="rgba(239, 68, 68, 0.1)" stopOpacity={0.1}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" className="stroke-gray-200 opacity-50" />
              <XAxis dataKey="mes" />
              <YAxis 
                tickFormatter={(value) => 
                  new Intl.NumberFormat('pt-BR', {
                    notation: 'compact',
                    compactDisplay: 'short',
                    style: 'currency',
                    currency: 'BRL',
                  }).format(value)
                }
              />
              <ChartTooltip 
                content={
                  <ChartTooltipContent 
                    formatter={(value) => 
                      new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(value as number)
                    }
                  />
                }
              />
              <Area 
                type="monotone" 
                dataKey="valor" 
                stroke="rgba(239, 68, 68, 0.8)" 
                fillOpacity={1} 
                fill="url(#colorDespesas)" 
                name="Valor" 
              />
            </AreaChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default DespesasChart;
